export default __webpack_public_path__ + "static/media/work-full-screen.ee4d7f1f.svg";